module.exports = __webpack_public_path__ + "img/packet.20867178.svg";